<template>
  <div class="h-full">
    <div class="h-full flex flex-col lg:flex-row justify-between align-middle">
      <div class="h-full order-4 lg:order-3 w-full lg:w-1/2 bg-orange-400 hidden lg:flex justify-center items-center">
        <div class="">
          <div class="max-w-md font-bold">
            What is PeopleLinking.com ?
          </div>
          <div class=" max-w-md">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Enim quae quod minima maxime quos aliquid sapiente ipsa perspiciatis atque. Magni laudantium quasi eius ipsa nisi. Dolore amet totam debitis quod.
          </div>
        </div>
      </div>
      <div class="h-full order-3 lg:order-4 w-full lg:w-1/2 relative">
        <LoginForm class="absolute top-0 right-0 mx-4 my-4 hidden lg:block"></LoginForm>
        <LoginButton class="absolute top-0 right-0 mx-4 my-4 block lg:hidden"></LoginButton>

        <div class="mt-16 pt-16 flex items-center flex-col">
          <div class=" text-2xl font-medium text-orange-600">
            PeopleLinking.com
          </div>
          <Register class=" max-w-sm" :nologo="true"></Register>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Register: require('../pages-main/Register.vue').default,
    LoginButton: require('../uis-main/LoginButton.vue').default,
    LoginForm: require('../uis-main/LoginForm.vue').default
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="postcss">

</style>
